import React, { FC } from "react";
import { Modal } from "antd";
import { ModalComponentProps } from "interfaces/ClientInterface/IModal";

const ModalComponent: FC<ModalComponentProps> = ({
  visible,
  onOK,
  onCancel,
  title,
  children,
  modalWidth,
  okText,
  cancelText,
  className,
  bodyStyle,
  dataTestSelector,
  zIndex,
  isMaskClosable,
  showMask,
  footer,
}) => {
  return (
    <Modal
      title={title}
      centered={true}
      open={visible}
      onOk={onOK}
      onCancel={onCancel}
      width={modalWidth}
      okText={okText}
      cancelText={cancelText}
      className={className}
      bodyStyle={bodyStyle}
      data-test-selector={dataTestSelector}
      zIndex={zIndex}
      maskClosable={isMaskClosable}
      mask={showMask}
      footer={footer}
    >
      {children}
    </Modal>
  );
};
export default ModalComponent;
